import axios from "axios";

export function getMotivations() {
  return axios.get(
    `${process.env.REACT_APP_SISAPI}/v1/acropolis/miscs/motivations`
  );
}
